import React, { FunctionComponent } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import clsx from "clsx";
const useStyle = makeThemedStyles("CardCheckedBox", (theme) => ({
  container: {
    width: "100%",
    position: "relative",
    fontSize: "1.14em",
  },
  checkBtnBlack: {
    "& .MuiIconButton-label": {
      color: "black",
    },
  },
  checkBtnBlue: {
    "& .MuiIconButton-label": {
      color: "#162870",
    },
  },
  checkBtnWhite: {
    "& .MuiIconButton-label": {
      color: "white",
    },
  },
  checkBtn: {
    top: "15px",
    insetInlineEnd: "5px",
    position: "absolute",
    "& .MuiCheckbox-colorSecondary.Mui-checked": {
      color: "white",
    },
    "& span": {
      padding: "0",
    },
    "& svg": {
      fontSize: "30px",
    },
  },
}));

interface CardCheckedBoxProps {
  type: "white" | "black" | "blue";
  isOpen?: boolean;
  dx?: number;
  dy?: number;
  onClick?: (checked: boolean) => void;
}

const CardCheckedBox = (
  props: React.PropsWithChildren<CardCheckedBoxProps>
) => {
  const { isOpen } = props;
  const styles = useStyle();
  const dx = props.dx || 0;
  const dy = props.dy || 0;
  return (
    <div className={styles.container}>
      <div
        className={clsx(
          styles.checkBtn,
          props.type === "blue" && styles.checkBtnBlue,
          props.type === "white" && styles.checkBtnWhite,
          props.type === "black" && styles.checkBtnBlack
        )}
        style={{
          top: `${15 + dy}px`,
          insetInlineEnd: `${5 - dx}px`,
        }}
      >
        <Checkbox
          onChange={(ev) => {
            if (props.onClick) {
              props.onClick(ev.currentTarget.checked);
            }
          }}
          checked={isOpen}
          icon={<RadioButtonUncheckedIcon />}
          checkedIcon={<CheckCircleIcon />}
          size="medium"
          name="checkedH"
        />
      </div>
    </div>
  );
};
export default CardCheckedBox;
